import { GitFork } from "lucide-react";

import { BasicTooltip } from "@/components/ui/Tooltip";

const requestCountFormatter = Intl.NumberFormat("en-US", {
  notation: "compact",
});

const VersionHeader = ({
  number,
  counts,
  parentVersionNumber,
}: {
  number: number;
  counts: Record<number, number>;
  parentVersionNumber?: number | null;
}) => (
  <div className="ml-6 flex items-center justify-between gap-x-2">
    <div className="flex min-w-0 flex-row items-center gap-x-1">
      <div className="text-start font-medium">{`Version ${number}`}</div>
      {counts[number] ? (
        <span className="rounded-full bg-gray-300 px-2 py-0.5 text-xs font-medium text-gray-800">
          {requestCountFormatter.format(counts[number])}
        </span>
      ) : null}
    </div>
    {parentVersionNumber !== null && parentVersionNumber !== undefined ? (
      <BasicTooltip content={`Forked from Version ${parentVersionNumber}`}>
        <span className="inline-flex shrink-0 items-center gap-x-0.5 text-xs text-gray-500">
          <GitFork className="h-3 w-3" aria-hidden />
          <span>v{parentVersionNumber}</span>
        </span>
      </BasicTooltip>
    ) : null}
  </div>
);

export default VersionHeader;
